import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'

interface MarginEligibilityBadgeProps {
  eligible: boolean
  className?: string
}

export function MarginEligibilityBadge({
  eligible,
  className,
}: MarginEligibilityBadgeProps) {
  return (
    <Badge
      variant={eligible ? BadgeVariant.Success : BadgeVariant.Danger}
      className={className}
    >
      {eligible ? 'Eligible' : 'Not Eligible'}
    </Badge>
  )
}
